export const RULES_CONFIG_ROUTE_PATHS = {
  rulesConfig: '/rules-config',
};

export const RULES_CONFIG_API_PATHS = {
  conditions: '/v1/api/platform/payment-methods/rules/conditions',
  conditionsFilter: '/v1/api/platform/payment-methods/rules/conditions/filter',
  conditionById: (id: number | string) =>
    `/v1/api/platform/payment-methods/rules/conditions/${id}`,
  conditionValues: '/v1/api/platform/payment-methods/rules/conditions/values',
  conditionValuesFilter: '/v1/api/platform/payment-methods/rules/conditions/values/filter',
  conditionValueById: (id: number | string) =>
    `/v1/api/platform/payment-methods/rules/conditions/values/${id}`,
};

export const RULES_CONFIG_QUERY_KEYS = {
  conditions: 'rules-config:conditions',
  conditionsFilter: 'rules-config:conditions-filter',
  conditionValues: 'rules-config:condition-values',
  conditionValuesFilter: 'rules-config:condition-values-filter',
} as const;

export const RULE_CONDITION_CRITERIA = ['condition', 'result'] as const;
export type RuleConditionCriteria = (typeof RULE_CONDITION_CRITERIA)[number];

export const RULES_CONFIG_SCOPE = 'rules-config';
